module.exports = __webpack_public_path__ + "static/media/mario.55219ce6.png";